export default {
  getTranslations: state => state.translations,
  getTranslationByOperator: state => (ordinal, key) => {
    const indexKey = (ordinal ? `${key}.${ordinal}` : key);
    return state.translations[indexKey] || state.translations[key];
  },
  getTranslationByOperatorIfExists: state => (ordinal, key) => {
    const indexKey = (ordinal ? `${key}.${ordinal}` : key);
    return state.translations[indexKey];
  },
  getLocale: state => state.currentLocale,
  getDefaultLanguage: state => state.defaultLanguage,
  getDisplayedLocale: state => state.availableLocales[state.currentLocale],
  getTranslationsKeys: state => Object.keys(state.translations),
};




// WEBPACK FOOTER //
// ./src/store/modules/i18n/getters.js